import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing, shadows, palette }) => ({
  root: {
    boxShadow: shadows[2],
    backgroundColor: palette.background.paper
  },
  toolbar: {
    padding: spacing(2, 3),
    minHeight: "auto"
  },
  toolbarItem: {
    display: "flex",
    justifyContent: "center",

    ":first-of-type": {
      justifyContent: "start"
    },
    ":last-of-type": {
      justifyContent: "end"
    }
  }
}))
